<template>
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.03597 0C3.61782 0 0.0361023 3.58182 0.0361023 7.99987C0.0361023 12.4179 3.61782 16 8.03597 16C12.4541 16 16.0361 12.4179 16.0361 7.99987C16.0361 3.58182 12.4541 0 8.03597 0ZM11.4945 9.52144H8.1029C8.09144 9.52144 8.08077 9.51867 8.06941 9.51824C8.05805 9.51877 8.04744 9.52144 8.03592 9.52144C7.73036 9.52144 7.48263 9.2737 7.48263 8.96815V3.32C7.48263 3.01445 7.73036 2.76671 8.03592 2.76671C8.34147 2.76671 8.5892 3.01445 8.5892 3.32V8.41486H11.4943C11.7999 8.41486 12.0476 8.6626 12.0476 8.96815C12.0476 9.2737 11.8001 9.52144 11.4945 9.52144Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'WaitingRoomClock',
};
</script>
